define("ember-concurrency/-private/external/scheduler/state-tracker/state-tracker", ["exports", "ember-concurrency/-private/external/scheduler/state-tracker/state"], function (_exports, _state) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  const CURRENT_REFRESH_TAGS = new Map();

  class StateTracker {
    constructor() {
      this.states = new Map();
    }

    stateFor(taskable) {
      let guid = taskable.guid;
      let taskState = this.states.get(guid);

      if (!taskState) {
        let currentTag = CURRENT_REFRESH_TAGS.has(guid) ? CURRENT_REFRESH_TAGS.get(guid) : 0;
        taskState = new _state.default(taskable, ++currentTag);
        this.states.set(guid, taskState);
        CURRENT_REFRESH_TAGS.set(guid, currentTag);
      }

      return taskState;
    } // After cancelling/queueing task instances, we have to recompute the derived state
    // of all the tasks that had/have task instances in this scheduler. We do this by
    // looping through all the Tasks that we've accumulated state for, and then recursively
    // applying/adding to the state of any TaskGroups they belong to.


    computeFinalStates(callback) {
      this.computeRecursiveState();
      this.forEachState(state => callback(state));
    }

    computeRecursiveState() {
      this.forEachState(taskState => {
        let lastState = taskState;
        taskState.recurseTaskGroups(taskGroup => {
          let state = this.stateFor(taskGroup);
          state.applyStateFrom(lastState);
          lastState = state;
        });
      });
    }

    forEachState(callback) {
      this.states.forEach(state => callback(state));
    }

  }

  var _default = StateTracker;
  _exports.default = _default;
});